import React, { useState } from "react";
import { AsyncPaginate } from "react-select-async-paginate";
import { listParams } from "../../services/pageOne";

const SelectAsyncArea = (props) => {
  const [itemsDonwload, setItemsDonwload] = useState({});

  const getDefaultValue = async () => {
    if (props.id) {
      const response = await listParams(7);
      const defaultValue = response.results.filter(
        (item) => item.id === props.id
      )[0];
      props.onChange(defaultValue);
    }
  };

  async function Options(searchQuery, { page }) {
    try {
      let resp = itemsDonwload;
      let nextHas = null;
      if (searchQuery.length == 0) {
        resp = await listParams(7);
        setItemsDonwload({
          ...resp,
          results: [...resp.results, ...(itemsDonwload?.results || [])],
        });
        nextHas = resp.next;
      } else {
        resp = itemsDonwload;
      }
      return {
        options: resp.results,
        hasMore: nextHas !== null,
        additional: {
          page: searchQuery ? 2 : page + 1,
        },
      };
    } catch (error) {}
  }
  const onChange = (option) => {
    if (typeof props.onChange === "function") {
      props.onChange(option);
    }
  };
  return (
    <>
      <AsyncPaginate
        styles={props.styles}
        key={(option) => option.id}
        value={props.value || getDefaultValue || ""}
        loadOptions={Options}
        getOptionValue={(option) => option.id}
        getOptionLabel={(option) => option.detalle}
        onChange={onChange}
        placeholder="Seleccionar"
        additional={{
          page: 1,
        }}
        isSearchable
        filterOption={(option, inputValue) =>
          option.label.toLowerCase().includes(inputValue.toLowerCase())
        }
      />
    </>
  );
};

export default SelectAsyncArea;
